import { Injectable } from '@angular/core';
import { HttpService, ListQuery } from './http.service';

@Injectable()
export class PortalAdminHttp {
  constructor(protected httpService: HttpService) {}

  getMasterData = async () => await this.httpService.get('/research-report/master-data');
  getEventMasterData = async (type, category) =>
    await this.httpService.get(`/${type}-event/master-data${(category && '?category=' + category) || ''}`);
  createResearchReport = async (researchReport) => await this.httpService.post('/research-report', researchReport);
  createMacroEvents = async (formData) => await this.httpService.post('/macro-event', formData);
  createEquityEvents = async (formData, category) =>
    await this.httpService.post(`/equity-event${(category && '?category=' + category) || ''}`, formData);
  getEquityEvents = async (listQuery) => await this.httpService.get('/equity-event');
  deleteEquityEvent = async (id) => await this.httpService.delete(`/equity-event?eventId=${id}`);
  getEquityById = async (id) => await this.httpService.get(`/equity-event/${id}`);
  addChangePortalAccess = async (user) => await this.httpService.postForm('/admin/change-research-portal-access-privilege', user);
  getThumbStoreLocation = async () => this.httpService.get('/media/research-portal-thumb-store-location');
  listAllCorporateAccounts = async (search, page = 0, size = 20) => {
    let params = {
      search,
      page,
      size,
    };
    return this.httpService.get(`/corporate-account`, params);
  };
  getCorporateAccounts = async (userId) => await this.httpService.get(`/users/${userId}/corporate-account`);
  addCorporateAccounts = async (userId, corporateUser) =>
    await this.httpService.post(`/users/${userId}/corporate-account?corporateAccountId=${corporateUser}`);
  deleteCorporateAccounts = async (userId, corporateUser) =>
    await this.httpService.delete(`/users/${userId}/corporate-account?corporateAccountId=${corporateUser}`);
  getEditableProducts = async (userId) => await this.httpService.get(`/admin/users/${userId}/editable-products`);
  postSignUpEnableInfo = async (editableInfo) =>
    await this.httpService.put(`/admin/users/${editableInfo.userId}/products/${editableInfo.productId}/modify`, editableInfo);
  getSignUpEnableInfo = async (userId, productId) => await this.httpService.get(`/admin/users/${userId}/products/${productId}/modify`);
}

@Injectable()
export class PortalAdminService {
  constructor(protected http: PortalAdminHttp) {}
  async createResearchReport(researchReport) {
    return await this.http.createResearchReport(researchReport);
  }
  async createMacroEvents(formData) {
    return await this.http.createMacroEvents(formData);
  }
  async createEquityEvents(formData, category) {
    return await this.http.createEquityEvents(formData, category);
  }
  async getEquityEvents(listQuery?) {
    return await this.http.getEquityEvents(listQuery);
  }
  async deleteEquityEvent(id) {
    return await this.http.deleteEquityEvent(id);
  }
  async getEquityById(id) {
    return await this.http.getEquityById(id);
  }

  async getMasterData() {
    return await this.http.getMasterData();
  }
  async getEventMasterData(type, category?) {
    return await this.http.getEventMasterData(type, category);
  }
  async addChangePortalAccess(user) {
    return await this.http.addChangePortalAccess(user);
  }
  async getThumbStoreLocation() {
    return await this.http.getThumbStoreLocation();
  }
  async listAllCorporateAccounts(search, page?, size?) {
    return await this.http.listAllCorporateAccounts(search, page, size);
  }
  async getCorporateAccounts(userId) {
    return await this.http.getCorporateAccounts(userId);
  }
  async addCorporateAccounts(userId, corporateUser) {
    return await this.http.addCorporateAccounts(userId, corporateUser);
  }
  async deleteCorporateAccounts(userId, corporateUser) {
    return await this.http.deleteCorporateAccounts(userId, corporateUser);
  }
  async getEditableProducts(userId) {
    return await this.http.getEditableProducts(userId);
  }
  async postSignUpEnableInfo(editableInfo) {
    return await this.http.postSignUpEnableInfo(editableInfo);
  }
  async getSignUpEnableInfo(userId, productId) {
    return await this.http.getSignUpEnableInfo(userId, productId);
  }
}
